"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GrammarDescriptionFlagQuestionsWithTitle = void 0;
var GrammarDescriptionFlagQuestions = {
  EN: "What's wrong with this grammar explainer?",
  EN2: "What's wrong with this grammar explainer?",
  SQ: 'Çfarë nuk shkon me këtë shpjegim gramatikor?',
  AR: 'ما المشكلة في هذا الشرح النحوي؟',
  BN: 'ব্যাকরণের এই ব্যাখ্যায় কী সমস্যা আছে?',
  BG: 'Какъв е проблемът с това граматическо обяснение?',
  ZH: '这段语法讲解有什么问题？',
  ZH2: '這段文法說明有什麼問題？',
  HR: 'Što nije u redu s ovim gramatičkim objašnjenjem?',
  CS: 'Co je špatně na tomto vysvětlení gramatiky?',
  DA: 'Hvad er der galt med denne grammatikforklaring?',
  NL: 'Wat klopt er niet aan deze grammaticale uitleg?',
  FI: 'Mikä tässä kielioppiselityksessä on vialla?',
  FR: 'Quel est le problème avec cette explication de grammaire ?',
  DE: 'Was stimmt mit dieser Grammatikerklärung nicht?',
  EL: 'Ποιο είναι το πρόβλημα με αυτή την εξήγηση γραμματικής;',
  IW: 'מה הבעיה בהסבר הדקדוקי הזה?',
  HI: 'व्याकरण की इस व्याख्या में क्या समस्या है?',
  HU: 'Mi a probléma ezzel a nyelvtani magyarázattal?',
  IN: 'Apa yang salah dengan penjelasan tata bahasa ini?',
  IT: 'Qual è il problema con questa spiegazione grammaticale?',
  JA: 'この文法の解説にはどのような問題がありますか？',
  KO: '이 문법 설명에 어떤 문제가 있나요?',
  NO: 'Hva er galt med denne grammatikkforklaringen?',
  FA: 'این توضیح دستور زبان چه مشکلی دارد؟',
  PL: 'Co jest nie tak z tym wyjaśnieniem gramatycznym?',
  PT2: 'Qual é o problema com esta explicação gramatical?',
  PT: 'Qual é o problema com esta explicação gramatical?',
  RO: 'Ce este în neregulă cu această explicație gramaticală?',
  RU: 'Что не так с этим объяснением грамматики?',
  SR: 'Шта није у реду са овим граматичким објашњењем?',
  SK: 'Čo nie je v poriadku s týmto vysvetlením gramatiky?',
  ES: '¿Qué problema hay con esta explicación gramatical?',
  SV: 'Vad är det för fel på den här grammatikförklaringen?',
  TR: 'Bu dil bilgisi açıklamasında ne sorun var?',
  UK: 'Що не так із цим поясненням граматики?',
  UZ: 'Ushbu grammatika izohida qanday muammo bor?',
  VI: 'Phần giải thích ngữ pháp này có vấn đề gì?'
};
var _default = exports["default"] = GrammarDescriptionFlagQuestions;
var GrammarDescriptionFlagQuestionsWithTitle = exports.GrammarDescriptionFlagQuestionsWithTitle = {
  EN: "What's wrong with the ‘{title}’ explainer?",
  EN2: "What's wrong with the ‘{title}’ explainer?",
  SQ: 'Çfarë nuk shkon me shpjegimin «{title}»?',
  AR: 'ما المشكلة في شرح «{title}»؟',
  BN: '«{title}» ব্যাখ্যায় কী সমস্যা আছে?',
  BG: 'Какъв е проблемът с обяснението „{title}“?',
  ZH: '“{title}”的讲解有什么问题？',
  ZH2: '「{title}」的說明有什麼問題？',
  HR: 'Što nije u redu s objašnjenjem „{title}“?',
  CS: 'Co je špatně na vysvětlení „{title}“?',
  DA: 'Hvad er der galt med forklaringen »{title}«?',
  NL: 'Wat klopt er niet aan de uitleg ‘{title}’?',
  FI: 'Mikä selityksessä ”{title}” on vialla?',
  FR: 'Quel est le problème avec l’explication « {title} » ?',
  DE: 'Was stimmt mit der Erklärung „{title}“ nicht?',
  EL: 'Ποιο είναι το πρόβλημα με την εξήγηση «{title}»;',
  IW: 'מה הבעיה בהסבר „{title}“?',
  HI: '“{title}” की व्याख्या में क्या समस्या है?',
  HU: 'Mi a probléma a(z) „{title}” magyarázattal?',
  IN: 'Apa yang salah dengan penjelasan “{title}”?',
  IT: 'Qual è il problema con la spiegazione «{title}»?',
  JA: '「{title}」の解説にはどのような問題がありますか？',
  KO: '“{title}” 설명에 어떤 문제가 있나요?',
  NO: 'Hva er galt med forklaringen «{title}»?',
  FA: 'توضیح «{title}» چه مشکلی دارد؟',
  PL: 'Co jest nie tak z wyjaśnieniem „{title}”?',
  PT2: 'Qual é o problema com a explicação “{title}”?',
  PT: 'Qual é o problema com a explicação «{title}»?',
  RO: 'Ce este în neregulă cu explicația „{title}”?',
  RU: 'Что не так с объяснением «{title}»?',
  SR: 'Шта није у реду са објашњењем „{title}“?',
  SK: 'Čo nie je v poriadku s vysvetlením „{title}“?',
  ES: '¿Qué problema hay con la explicación «{title}»?',
  SV: 'Vad är det för fel på förklaringen ”{title}”?',
  TR: '“{title}” açıklamasında ne sorun var?',
  UK: 'Що не так із поясненням «{title}»?',
  UZ: '“{title}” izohida qanday muammo bor?',
  VI: 'Phần giải thích “{title}” có vấn đề gì?'
};